export class GridConfig {
  public static center_color = 0xFF0000;
  public static grid_size = 10000;
  public static grid_divisions = 200;
}
